export default __webpack_public_path__ + "static/media/Plus.04054765.svg";